module.exports = __webpack_public_path__ + "static/img/news_00.6f5e1c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news_00.png
// module id = qsSa
// module chunks = 0